import { Cpu, Shield, ShieldAlert, ShieldCheck, Zap, Snowflake } from "lucide-react";

export const FpsBadge = ({ fps }) => {
  const green = fps >= 90;
  return (
    <span
      data-testid="fps-badge"
      className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-heading font-semibold ${
        green ? "bg-graphite text-neon border-neon/50" : "bg-graphite text-cyber border-cyber/50"
      }`}
    >
      <Zap className="h-3 w-3" /> {fps} FPS
    </span>
  );
};

export const PtaBadge = ({ status }) => {
  const s = (status || "").toLowerCase();
  const approved = s.includes("approved") || s.includes("usually pta");
  const cpid = s.includes("cpid") || s.includes("patched");
  const nonPta = s.includes("non-pta") || s.includes("non pta") || s.includes("not approved") || s.includes(" jv") || s.includes("kit");
  // No recognizable PTA info -> don't show a badge at all.
  if (!approved && !cpid && !nonPta) return null;
  const Icon = approved ? ShieldCheck : cpid ? ShieldAlert : Shield;
  const cls = approved
    ? "bg-neon/10 text-neon border-neon/30"
    : cpid
    ? "bg-amberw/10 text-amberw border-amberw/30"
    : "bg-dangerr/10 text-dangerr border-dangerr/30";
  return (
    <span data-testid="pta-badge" className={`inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-medium ${cls}`}>
      <Icon className="h-3 w-3" /> {approved ? "PTA Verified" : cpid ? "CPID (verify)" : "Non-PTA (verify)"}
    </span>
  );
};

export const ConditionBadge = ({ label }) => (
  <span className="inline-flex items-center rounded-md border border-cyber/40 bg-cyber/10 px-2 py-0.5 text-xs font-medium text-cyber">
    {label}
  </span>
);

export const CoolingBadge = ({ rating }) => (
  <span className="inline-flex items-center gap-1 rounded-md border border-border bg-graphite px-2 py-0.5 text-xs text-slate-300">
    <Snowflake className="h-3 w-3 text-cyber" /> {rating} cooling
  </span>
);

export const ChipBadge = ({ chipset }) => (
  <span className="inline-flex items-center gap-1 rounded-md border border-border bg-graphite px-2 py-0.5 text-xs text-slate-300">
    <Cpu className="h-3 w-3 text-neon" /> {chipset}
  </span>
);
